import { Button, Typography, styled } from '@material-ui/core';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  padding: theme.spacing(3),
  position: 'relative',
}));

export const MainContent = styled('div')(({ theme }) => ({
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const CardsWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(3),
}));

export const ShowFiltersButton = styled(Button)(({ theme }) => ({
  borderRadius: 10,
  color: theme.palette.text.primary,
  border: `1px solid ${theme.palette.border}`,
  backgroundColor: theme.palette.common.white,
  textTransform: 'capitalize',
  padding: theme.spacing(1, 2),
}));

export const EmptyState = styled('div')(({ theme }) => ({
  textAlign: 'center',
  padding: theme.spacing(8, 2),
  color: theme.palette.text.secondary,
}));

export const EmptyStateTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  fontWeight: 600,
}));
